// Animação (cérebro) da Memor.IA, servida pelo próprio front (public/memora_mascote.json).
// Substitui os iframes do lottie.host, que somem quando o site externo é bloqueado
// pela rede/extensão do navegador ou fica fora do ar.
import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export const SRC_ANIMACAO_MEMORA = `${process.env.PUBLIC_URL || ''}/memora_mascote.json`;

export default function MemoraAnimacao({ tamanho = 120, style = {} }) {
  return (
    <div aria-hidden="true" style={{ width: tamanho, height: tamanho, ...style }}>
      <DotLottieReact src={SRC_ANIMACAO_MEMORA} loop autoplay />
    </div>
  );
}
